<template>
  <div class="hm-goods-picker">
    <div class="picked-container">
      <div class="picked-header flex flex-between item-center">
        <div class="caption">
          <el-button
            size="small"
            type="text"
            @click="openDialog"
            :disabled="isPreview"
            >{{ buttonText }}></el-button
          >
          <span class="picked-title">{{ title }}</span>
        </div>
        <span class="status">状态</span>
      </div>
      <div class="picked-list">
        <div
          v-for="(v, i) in pickedList"
          :key="i"
          class="flex flex-between item-center picked-item"
        >
          <span class="name flex-2">{{
            v.name || v.goodsName || v.productName
          }}</span>
          <span :class="v.useable === 1 ? 'succ' : 'danger'">{{
            v.useable === 1 ? "白" : "黑"
          }}</span>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="80%"
      style="min-width: 1300px"
    >
      <div class="search-panel">
        <div class="transfer-panel">
          <!-- <div v-show="offline && title === '品类'">
            <div class="tip">提示：由于默认品类数据量十分庞大，未搜索筛选直接使用全选功能会造成浏览器卡顿！</div>
            <el-input size="small" v-model="offlineCat" placeholder="请输入品类"  ></el-input>
             <el-button size="small" type="primary" class="hmicon icon-search"   @click="queryOfflineCategory('offlineCat')"></el-button>
          </div>-->
          <div v-show="offline && title === '品牌'">
            <el-input
              size="small"
              v-model="offlineBrand"
              placeholder="请输入品牌"
            ></el-input>
            <el-button
              size="small"
              type="primary"
              class="hmicon icon-search"
              @click="queryOfflineCategory('offlineBrand')"
            ></el-button>
          </div>
          <div v-show="offline && title === '商品'">
            <div class="category-wrapper">
              <span>选择品类</span>
              <el-tree
                empty-text="暂无品类"
                :props="props"
                :load="loadNode"
                node-key="id"
                ref="tree"
                highlight-current
                lazy
                show-checkbox
                @check-change="handleCheckChange"
              ></el-tree>
            </div>
            <!-- <el-cascader :options="categoryTree" @active-item-change="handleItemChange" :props="props"  ></el-cascader> -->
            <!-- <el-tree show-checkbox :data="offlineCategoryList" :props="defaultProps" ref="tree" style="width: 500px" node-key="id"></el-tree> -->
            <el-select
              size="small"
              clearable
              placeholder="选择品牌"
              :disabled="isPreview"
              v-model="brandId"
              style="width: 200px"
              filterable
            >
              <el-option
                v-for="(item, i) in offlineBrandList"
                :key="i"
                :label="item.name"
                :value="item.objectId"
              ></el-option>
            </el-select>
            <el-input
              size="small"
              clearable
              placeholder="商品关键字"
              :disabled="isPreview"
              v-model.trim="goodsName"
            ></el-input>
            <el-button
              size="small"
              :disabled="isPreview"
              @click="resetGoodsList"
              class="hmicon icon-zhongzhi"
            ></el-button>
            <el-button
              size="small"
              :disabled="brandId === '' && !isChecked && goodsName === ''"
              type="primary"
              class="hmicon icon-search"
              style="margin-left: 0"
              @click="queryGoodsList"
            ></el-button>
          </div>
          <div v-show="!offline && title === '品类'">
            <el-input
              size="small"
              v-model="onlineCat"
              placeholder="请输入品类"
            ></el-input>
            <el-button
              size="small"
              type="primary"
              class="hmicon icon-search"
              @click="queryOfflineCategory('onlineCat')"
            ></el-button>
          </div>
          <div v-show="!offline && title === '品牌'">
            <div class="tip">
              提示：由于默认品牌数据量十分庞大，未搜索筛选直接使用全选功能会造成浏览器卡顿！
            </div>
            <el-input
              size="small"
              v-model="onlineBrand"
              placeholder="请输入品类"
            ></el-input>
            <el-button
              size="small"
              type="primary"
              class="hmicon icon-search"
              @click="queryOfflineCategory('onlineBrand')"
            ></el-button>
          </div>
          <div v-show="!offline && title === '商品'">
            <el-select
              size="small"
              clearable
              placeholder="选择品类"
              v-model="catId"
              style="width: 200px"
              filterable
            >
              <el-option
                v-for="(item, i) in categoryList"
                :key="i"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              size="small"
              clearable
              placeholder="选择品牌"
              v-model="brandId"
              style="width: 200px"
              filterable
            >
              <el-option
                v-for="(item, i) in brandList"
                :key="i"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-input
              size="small"
              clearable
              placeholder="商品关键字"
              v-model.trim="goodsName"
            ></el-input>
            <el-button
              size="small"
              @click="resetGoodsList"
              class="hmicon icon-zhongzhi"
            ></el-button>
            <el-button
              size="small"
              type="primary"
              class="hmicon icon-search"
              style="margin-left: 0"
              @click="queryGoodsList"
              :disabled="brandId === '' && catId === '' && goodsName === ''"
            ></el-button>
          </div>
          <div v-show="sysTag === 'service'" class="mb20">
            <el-select
              size="small"
              clearable
              placeholder="选择产品分类"
              v-model="serviceCategoryId"
              style="margin-right: 10px"
              filterable
            >
              <el-option
                v-for="(item, i) in serviceCategoryList"
                :key="i"
                :label="item.categoryName"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-input
              size="small"
              style="margin-right: 10px"
              clearable
              placeholder="产品关键字"
              v-model.trim="serviceProductName"
            ></el-input>
            <el-button
              size="small"
              type="primary"
              class="hmicon icon-search"
              style="margin-left: 0"
              @click="queryServiceProductList"
            ></el-button>
          </div>
        </div>
      </div>
      <div class="flex item-center">
        <div class="goods-picker">
          <div class="picker-header">
            <div class="flex transfer-header">
              <div class="select flex-2 text-center">
                <el-checkbox
                  :indeterminate="leftIsIndeterminate"
                  :disabled="
                    leftData.length <= 0 ||
                      (this.offline && this.title === '品类')
                  "
                  v-model="leftCheckAll"
                  @change="handleLeftCheckAllChange"
                  style="float: left"
                  >全选</el-checkbox
                >
                <span class="leftName">待选{{ title }}</span>
              </div>
            </div>
          </div>
          <div class="picker-body">
            <el-checkbox-group
              :disabled="isPreview || (this.offline && this.title === '品类')"
              v-model="leftChecked"
              @change="handleLeftCheckedChange"
              v-show="!(offline && title === '品类')"
            >
              <div
                v-for="(v, i) in leftData"
                :key="i"
                class="check-wrapper flex"
              >
                <div class="flex-2">
                  <el-checkbox :label="v">{{
                    v.name || v.realName || v.goodsName || v.productName
                  }}</el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
            <el-tree
              empty-text="暂无品类"
              :props="props"
              :load="loadNode"
              node-key="id"
              ref="categoryTree"
              highlight-current
              lazy
              show-checkbox
              @check-change="handleCheckChange"
              v-show="offline && title === '品类'"
            ></el-tree>
          </div>
        </div>
        <div class="flex flex-column control text-center">
          <div>操作</div>
          <el-switch
            :disabled="disableSwitch"
            :width="30"
            active-color="#13ce66"
            v-model="useable"
            active-text="黑名单"
            inactive-text="白名单"
            :active-value="0"
            :inactive-value="1"
            :class="[this.offline && this.title === '品类' ? 'mt1 mb1' : '']"
          ></el-switch>
          <el-button
            size="small"
            :disabled="leftData.length <= 0"
            class="hmicon icon-youshuangjiantou"
            @click="allToRight"
            v-show="!(this.offline && this.title === '品类')"
          ></el-button>
          <el-button
            size="small"
            :disabled="!leftCheckAll && leftChecked.length <= 0"
            class="hmicon icon-youjiantou"
            @click="toRight"
            :class="[this.offline && this.title === '品类' ? 'mt1 mb1' : '']"
          ></el-button>
          <el-button
            size="small"
            :disabled="rightData.length <= 0"
            class="hmicon icon-zuoshuangjiantou"
            @click="allToLeft"
            v-show="!(this.offline && this.title === '品类')"
          ></el-button>
          <el-button
            size="small"
            :disabled="!rightCheckAll && rightChecked.length <= 0"
            class="hmicon icon-mjiantou-copy"
            @click="toLeft"
            :class="[this.offline && this.title === '品类' ? 'mt1 mb1' : '']"
          ></el-button>
          <el-button
            size="small"
            class="hmicon icon-mjiantou-copy delete-selected"
            @click="deleteChecked"
            :disabled="
              leftChecked.length <= 0 || rightData.length <= 0 || isPreview
            "
            v-show="!(this.offline && this.title === '品类')"
          >
            剔除
            <el-tooltip
              class="item"
              effect="dark"
              content="剔除右侧列表和左侧已勾选的相同的选项"
              placement="top-end"
            >
              <i class="hmicon icon-wenhao"></i>
            </el-tooltip>
          </el-button>
        </div>
        <div class="goods-picker">
          <div class="picker-header flex flex-between item-center">
            <div class="select flex-2 text-center">
              <el-checkbox
                :indeterminate="rightIsIndeterminate"
                :disabled="rightData.length <= 0"
                v-model="rightCheckAll"
                @change="handleRightCheckAllChange"
                style="float: left"
                >全选</el-checkbox
              >
            </div>
            <span class="leftName">已选{{ title }}</span>
            <span class="type">状态</span>
          </div>
          <div class="picker-body">
            <el-checkbox-group
              :disabled="isPreview"
              v-model="rightChecked"
              @change="handleRightCheckedChange"
            >
              <div
                v-for="(v, i) in rightData"
                :key="i"
                class="check-wrapper flex flex-between item-center"
              >
                <div class="goods-name">
                  <el-checkbox :label="v">{{
                    v.name || v.realName || v.goodsName || v.productName
                  }}</el-checkbox>
                </div>
                <div class="type" :class="v.useable === 1 ? 'succ' : 'danger'">
                  {{ v.useable === 1 ? "白" : "黑" }}
                </div>
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { sortBy, uniqBy } from "lodash";
import axios from "axios";
export default {
  props: {
    title: { type: String },
    buttonText: { type: String },
    offline: { default: Boolean },
    isPreview: { type: Boolean },
    storeConfig: { type: Array },
    writeOffline: { type: Boolean },
    disableSwitch: { type: Boolean },
    sysTag: { type: String }
  },
  data() {
    return {
      serviceCategoryId: "",
      serviceProductName: "",
      offlineBrand: "",
      useable: 1,
      currentRef: "",
      totalCount: 0,
      dialogVisible: false,
      leftIsIndeterminate: false,
      leftOption: [],
      brandId: "",
      disabled: true,
      leftCheckAll: false,
      rightCheckAll: false,
      leftData: [],
      leftChecked: [],
      rightChecked: [],
      isChecked: false,
      goodsName: "",
      rightData: [],
      rightIsIndeterminate: false,
      offlineCat: "",
      onlineCat: "",
      onlineBrand: "",
      catIds: "",
      catId: "",
      pickedList: [],
      level: 1,
      props: {
        value: "id",
        label: "name",
        children: "children",
        isLeaf: "leaf"
      },
      compareItem: ""
    };
  },
  watch: {
    disableSwitch(val) {
      if (val) {
        this.useable = 1;
      }
    },
    dialogVisible() {
      this.leftData = [];
    },
    originCategory(val) {
      if (val.length > 0 && this.offline && this.title === "品类") {
        this.leftData = val;
      }
    },
    offlineBrandList(val) {
      if (val.length > 0 && this.offline && this.title === "品牌") {
        this.leftData = val;
      }
    },
    offlineGoodsList(val) {
      if (val.length > 0 && this.offline && this.title === "商品") {
        this.leftData = val;
      }
    },
    categoryList(val) {
      if (val.length > 0 && !this.offline && this.title === "品类") {
        this.leftData = val;
      }
    },
    brandList(val) {
      if (val.length > 0 && !this.offline && this.title === "品牌") {
        this.leftData = val;
      }
    },
    goodsList(val) {
      if (val.length > 0 && !this.offline && this.title === "商品") {
        this.leftData = val;
      }
    },
    serviceProductList(val) {
      if (val.length > 0) {
        this.leftData = val;
      }
    },
    pickedList() {
      this.$emit("getGoodsListLength", this.pickedList.length);
    }
  },
  computed: mapState({
    categoryTree: state => state.rules.categoryTree,
    originCategory: state => state.rules.originCategory,
    categoryLen: state => state.rules.categoryLen,
    brandList: state => state.rules.brandList,
    categoryList: state => state.rules.categoryList,
    goodsList: state => state.rules.goodsList,
    offlineBrandList: state => state.rules.offlineBrandList,
    offlineCategoryList: state => state.rules.offlineCategoryList,
    offlineGoodsList: state => state.rules.offlineGoodsList,
    serviceCategoryList: state => state.rules.serviceCategoryList,
    serviceProductList: state => state.rules.serviceProductList
  }),
  methods: {
    handleLeftCheckAllChange(val) {
      // 选择左边的全选
      this.leftChecked = val ? this.leftData : [];
      this.leftIsIndeterminate = false;
    },
    handleLeftCheckedChange(value) {
      let checkedCount = value.length;
      this.leftCheckAll = checkedCount === this.leftData.length;
      this.leftIsIndeterminate =
        checkedCount > 0 && checkedCount < this.leftData.length;
    },
    handleRightCheckAllChange(val) {
      // 选择右边的全选
      this.rightChecked = val ? this.rightData : [];
      this.rightIsIndeterminate = false;
    },
    handleRightCheckedChange(value) {
      // 选择右边的checkbox
      let checkedCount = value.length;
      this.rightCheckAll = checkedCount === this.rightData.length;
      this.rightIsIndeterminate =
        checkedCount > 0 && checkedCount < this.rightData.length;
    },
    allToRight() {
      // 移动所有到右边
      if (this.leftData.length > 0) {
        this.leftData.forEach(v => {
          v.useable = this.useable;
        });
        this.rightData = uniqBy(
          this.rightData.concat(this.leftData),
          this.compareItem
        );
        this.leftData = [];
        this.leftChecked = [];
      }
      this.handleRightCheckAllChange(true);
      this.leftCheckAll = false;
      this.rightCheckAll = true;
    },
    toRight() {
      // 移动选中到右边
      this.$refs.categoryTree.setCheckedNodes([]);
      this.leftChecked.forEach(v => {
        v.useable = this.useable;
      });
      this.rightData = uniqBy(
        sortBy(this.rightData.concat(this.leftChecked), v => v.useable),
        this.compareItem
      );
      if (this.leftChecked.length === this.leftData.length) {
        this.leftData = [];
      } else if (this.leftChecked.length === 1) {
        this.leftData.forEach((v, i) => {
          if (v[this.compareItem] === this.leftChecked[0][this.compareItem]) {
            this.leftData.splice(i, 1);
          }
        });
      } else {
        this.leftChecked.forEach(v => {
          this.leftData.forEach((item, index) => {
            if (v[this.compareItem] === item[this.compareItem]) {
              this.leftData.splice(index, 1);
            }
          });
        });
      }
      if (!(this.offline && this.title === "品类")) {
        this.leftChecked = [];
        this.leftIsIndeterminate = false;
        this.leftCheckAll = false;
      }
      this.handleRightCheckAllChange(true);
      this.rightCheckAll = true;
    },
    allToLeft() {
      // 移动所有到左边
      this.rightCheckAll = false;
      this.rightIsIndeterminate = false;
      if (this.rightData.length > 0) {
        this.leftData = uniqBy(
          this.leftData.concat(this.rightData),
          this.compareItem
        );
        this.rightData = [];
        this.rightChecked = [];
      }
    },
    toLeft() {
      // 移动选中到左边
      this.leftData = uniqBy(
        this.leftData.concat(this.rightChecked),
        this.compareItem
      );
      if (this.rightChecked.length === this.rightData.length) {
        this.rightData = [];
        this.rightChecked = [];
        this.rightCheckAll = false;
      } else if (this.rightChecked.length === 1) {
        this.rightData.forEach((v, i) => {
          if (v[this.compareItem] === this.rightChecked[0][this.compareItem]) {
            this.rightData.splice(i, 1);
          }
        });
        this.rightChecked = [];
      } else {
        this.rightChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v[this.compareItem] === item[this.compareItem]) {
              this.rightData.splice(index, 1);
            }
          });
        });
      }
      this.rightIsIndeterminate = false;
    },
    deleteChecked() {
      // 剔除右边和左边相同的
      if (this.leftChecked.length > 0) {
        this.leftChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (this.title === "商品" && v.goodsName === item.goodsName) {
              this.rightData.splice(index, 1);
            }
            if (this.title !== "商品" && v.name === item.name) {
              this.rightData.splice(index, 1);
            }
          });
        });
        this.rightCheckAll = false;
        this.rightChecked = [];
      }
    },
    handleCheckChange() {
      this.isChecked = this.$refs.tree.getCheckedNodes().length > 0;
      this.leftChecked = this.$refs.categoryTree.getCheckedNodes();
    },
    queryServiceProductList() {
      this.$store.dispatch("queryServiceProductList", {
        categoryId: this.serviceCategoryId,
        productName: this.serviceProductName
      });
    },
    openDialog() {
      this.dialogVisible = true;
      this.leftData = [];
      // 服务项目
      // 如果是服务项目
      if (this.sysTag === "service") {
        this.$store.dispatch("queryServiceCategoryList");
        this.compareItem = "goodsId";
      } else {
        // 如果是原优惠券项目
        if (this.offline && this.title === "品类") {
          //
        } else if (this.offline && this.title === "品牌") {
          this.$store.dispatch("queryOfflineBrand");
        } else if (!this.offline && this.title === "品类") {
          this.$store.dispatch("queryCategory");
        } else if (!this.offline && this.title === "品牌") {
          this.$store.dispatch("queryBrand");
        } else if (this.offline && this.title === "商品") {
          this.$store.dispatch("queryOfflineBrand");
        } else if (!this.offline && this.title === "商品") {
          this.$store.dispatch("queryCategory");
          this.$store.dispatch("queryBrand");
        }
        this.compareItem =
          this.title === "品类"
            ? "id"
            : this.title === "品牌"
              ? "objectId"
              : "goodsId";
      }
      // 点击选择商品时将已选择列表回选至dialog已选商品
      if (this.pickedList.length > 0) {
        this.rightData = this.pickedList;
        this.rightChecked = this.pickedList;
        this.rightCheckAll = true;
      }
    },
    queryOfflineCategory(type) {
      let result = [];
      if (type === "offlineCat") {
        // 搜索线下品类
        if (this.offlineCat === "") {
          result = this.originCategory;
        } else {
          this.originCategory.forEach(v => {
            if (v.name.includes(this.offlineCat)) {
              result = result.concat(v);
            }
          });
        }
      } else if (type === "offlineBrand") {
        // 搜索线下品牌
        if (this.offlineBrand === "") {
          result = this.offlineBrandList;
        } else {
          this.offlineBrandList.forEach(v => {
            if (v.name.includes(this.offlineBrand)) {
              result = result.concat(v);
            }
          });
        }
      } else if (type === "onlineCat") {
        if (this.onlineCat === "") {
          result = this.categoryList;
        } else {
          this.categoryList.forEach(v => {
            if (v.name.includes(this.onlineCat)) {
              result = result.concat(v);
            }
          });
        }
      } else if (type === "onlineBrand") {
        if (this.onlineBrand === "") {
          result = this.brandList;
        } else {
          this.brandList.forEach(v => {
            if (v.name.includes(this.onlineBrand)) {
              result = result.concat(v);
            }
          });
        }
      }
      this.leftData = result;
    },
    resetGoodsList() {
      this.catId = "";
      this.brandId = "";
      this.goodsName = "";
    },
    save() {
      this.pickedList = this.rightChecked;
      this.pickedList.forEach(v => {
        if (v.children) {
          delete v.children;
        }
        if (!this.offline && this.title === "品牌") {
          v.objectId = v.id;
        } else if (this.title === "商品") {
          v.name = v.name || v.goodsName;
        }
      });
      // 分类与品牌互斥 0
      // 分类与商品互斥 1
      // 品牌与商品互斥 2
      if (this.pickedList.length > 0) {
        // 是否写入线下的券
        if (this.writeOffline) {
          this.storeConfig.forEach(v => {
            if (v === "0") {
              if (this.title === "品类") {
                // 禁止选品牌
                this.$emit("getCurrentRef", "offlineBrand");
              } else if (this.title === "品牌") {
                // 禁止选品类
                this.$emit("getCurrentRef", "offlineCat");
              }
            } else if (v === "1") {
              if (this.title === "品类") {
                // 禁止选商品
                this.$emit("getCurrentRef", "offlineGoods");
              } else if (this.title === "商品") {
                // 禁止选品类
                this.$emit("getCurrentRef", "offlineCat");
              }
            } else if (v === "2") {
              if (this.title === "品牌") {
                // 禁止选商品
                this.$emit("getCurrentRef", "offlineGoods");
              } else if (this.title === "商品") {
                // 禁止选品牌
                this.$emit("getCurrentRef", "offlineBrand");
              }
            }
          });
        }
        if (this.title === "商品") {
          this.$emit("getGoodsListLength", this.pickedList.length);
        }
      } else {
        this.$emit("getCurrentRef", "reset");
        if (this.title === "商品") {
          this.$emit("getGoodsListLength", 0);
        }
      }
      this.dialogVisible = false;
    },
    queryGoodsList() {
      const catIds = [];
      this.selectedCategory = this.$refs.tree.getCheckedNodes();
      this.selectedCategory.forEach(v => {
        catIds.push(v.id);
      });
      if (!this.offline) {
        this.$store.dispatch("queryGoodsList", {
          brandId: this.brandId,
          storeCatId: this.catId,
          goodsName: this.goodsName,
          currentPage: 1,
          pageSize: 1000
        });
      } else {
        const brandIds = this.brandId !== "" ? [this.brandId] : [];
        this.$store.dispatch("queryOfflineGoodsList", {
          brandIds,
          catIds,
          goodsName: this.goodsName,
          currentPage: 1,
          pageSize: 100
        });
      }
      this.leftGoodsList = [];
    },
    // 异步树叶子节点懒加载逻辑
    loadNode(node, resolve) {
      // 一级节点处理
      if (
        this.offline &&
        (this.title === "品类" || this.title === "商品") &&
        node.level === 0
      ) {
        this.requestTree(resolve);
      }
      // 其余节点处理
      if (
        this.offline &&
        (this.title === "品类" || this.title === "商品") &&
        node.level >= 1
      ) {
        // 注意！把resolve传到你自己的异步中去
        this.getIndex(node, resolve);
      }
    },
    // 异步加载叶子节点数据函数
    getIndex(node, resolve) {
      axios
        .post(this.$serverAdress + "/coupon/get_category_offline", {
          offlineId: node.data.id,
          level: node.level
        })
        .then(res => {
          const data = res.data.result.result;
          if (this.offline && this.title === "品牌") {
            this.leftData = data;
          }
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    // 首次加载一级节点数据函数
    requestTree(resolve) {
      axios
        .post(this.$serverAdress + "/coupon/get_category_offline", {
          offlineId: "",
          level: 0
        })
        .then(res => {
          const data = res.data.result.result;
          if (this.offline && this.title === "品牌") {
            this.leftData = data;
          }
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.picked-container {
  border: 1px solid #eceef5;
  border-radius: 3px;
}
.picked-header {
  position: relative;
  background: #f0f1fd;
  padding: 0 10px;
  height: 51px;
  font-size: 14px;
  .picked-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.picked-header.goods {
  .caption {
    width: 250px;
  }
}
.picked-list.goods {
  .name {
    width: 250px;
  }
}

.picked-list {
  height: 403px;
  padding: 10px;
  overflow-y: scroll;
  font-size: 14px;
  .whitelist {
    border-right: 1px solid #eceef5;
    .sub-title {
      color: #ff507a;
    }
  }
  .blacklist {
    .sub-title {
      color: #537ff6;
    }
  }
  .whitelist,
  .blacklist {
    width: 50%;
    box-sizing: border-box;
    .sub-title {
      font-size: 0.8rem;
      padding: 0.5rem 10px 10px 10px;
    }
  }
}

.hm-goods-picker {
  flex-basis: 32%;
}

.goods-picker {
  border: 1px solid #e7e8ec;
  height: 485px;
  width: 500px;
  border-radius: 5px;
}
.picker-header {
  position: relative;
  padding: 10px;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
}
.picker-header.goods {
  .select {
    width: 250px;
  }
  .count {
    width: 60px;
    text-align: center;
  }
}
.picker-body {
  padding: 10px;
  border-radius: 0 0 5px 5px;
  height: 403px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.leftName {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.check-wrapper {
  height: 2rem;
  font-size: 14px;
}

.check-wrapper.goods {
  margin-bottom: 10px;
  .goods-name {
    width: 250px;
  }
}

.succ,
.danger {
  width: 2rem;
  height: 10px;
  line-height: 10px;
  text-align: center;
  font-size: 0.7rem;
  border-radius: 3px;
}

.danger {
  background: #ffe7ef;
  color: #ff507a;
}

.succ {
  border: 1px solid #e7e8ec;
  background: #fff;
  color: #537ff6;
}

.picked-list {
  li {
    padding: 0 10px;
    .name {
      padding-left: 10px;
      flex: 2;
      text-align: center;
    }
  }
}
input[type="number"] {
  width: 2rem;
  border: none;
  outline: none;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.control {
  margin: 0 10px;
  min-width: 130px;
  .el-button {
    margin: 0.5rem;
  }
}

.picked-item {
  margin: 0.5rem 0;
  line-height: 20px;
}

.category-wrapper {
  height: 300px;
  overflow-y: scroll;
}

.disabled {
  color: rgb(220, 223, 230);
  cursor: not-allowed;
}
</style>
